// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3TAYA","copy-icon":"classes_copy-icon__3_p1l"};